import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error: err } = await supabase.auth.signInWithPassword({ email, password });
    if (err) {
      setError('이메일 또는 비밀번호가 올바르지 않습니다.');
    } else {
      navigate('/admin');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F8F9FB] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl border border-gray-100 p-10 w-full max-w-sm">
        <div className="mb-8 text-center">
          <p className="text-xs font-sans text-navy/40 tracking-[0.2em] uppercase mb-2">Admin</p>
          <h1 className="font-serif text-navy text-2xl font-bold">관리자 로그인</h1>
        </div>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-xs font-sans text-navy/50 mb-1.5">이메일</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm font-sans text-navy outline-none focus:border-navy transition-colors"
              placeholder="admin@example.com"
            />
          </div>
          <div>
            <label className="block text-xs font-sans text-navy/50 mb-1.5">비밀번호</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm font-sans text-navy outline-none focus:border-navy transition-colors"
              placeholder="••••••••"
            />
          </div>
          {error && <p className="text-red-500 text-xs font-sans">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-navy text-white text-sm font-sans font-semibold py-3 rounded-lg hover:bg-navy/90 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
          >
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
      </div>
    </div>
  );
}
